import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { SafeResourceUrl } from '@angular/platform-browser';
import { SetConsent } from 'projects/tools/src/lib/store/puzzle-analytics-consent.actions';
import { PuzzleFrameworkService } from 'projects/tools/src/lib/puzzle-framework-module/puzzle-framework.service';
import {
  ModalController,
  IonButton,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonItem,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { PuzzleAnalyticsService } from './puzzle-analytics.service';

@Component({
  selector: 'lib-app-puzzle-analytics-dialog',
  templateUrl: './puzzle-analytics-dialog.component.html',
  styleUrls: ['./puzzle-analytics-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonButton,
    IonCheckbox,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonItem,
    IonRow,
    IonText,
    IonTitle,
    IonToolbar,
    TranslateModule,
  ],
})
export class PuzzleAnalyticsDialogComponent {
  localConsent = false;
  globalConsent = false;
  @Input() requestConsent = true;
  privacyUrl: SafeResourceUrl;
  private consentSubscription: Subscription;

  constructor(
    // public dialogRef: MatDialogRef<PuzzleAnalyticsDialogComponent>,
    private store: Store,
    private framework: PuzzleFrameworkService,
    // @Inject(MAT_DIALOG_DATA) public data: any
    private ionicModal: ModalController,
    public analytics: PuzzleAnalyticsService
  ) {
    // Prepare the privacy URL using the framework service
    this.privacyUrl = this.framework.preparePrivacyUrl(
      this.framework.puzzleFrameworkConfig.privacyPolicy,
      this.analytics.enabled
    );

    this.consentSubscription = this.store
      .select((state) => state.cookieConsent)
      .subscribe((consent) => {
        this.localConsent = consent;
        this.globalConsent = consent;
      });
  }

  async closeDialog() {
    if (this.requestConsent === false) {
      await this._closeDialog();
      return;
    }
    if (this.localConsent) {
      this.store.dispatch(new SetConsent());
      await this._closeDialog();
    } else if (this.globalConsent) {
      await this._closeDialog(true);
    }
  }

  private async _closeDialog(revokeConsent = false) {
    this.consentSubscription.unsubscribe();
    // this.dialogRef.close(revokeConsent);
    await this.ionicModal.dismiss(revokeConsent);
  }
}
